import React from "react";

const StyledButton = ({ submitHandler, text, type, className, onClick, border = '0px', backgroundColor = "var(--base-color-dark-blue)", textColor = "white", width, height, padding }) => {
    const localStyle = {
        backgroundColor,
        color: textColor,
        border,
        width,
        height,
        padding
    }

    return (
        <button className={className} style={localStyle} type={type} onSubmit={submitHandler} onClick={onClick} ><b>{text}</b></button >
    )
}

export default StyledButton;